module.exports = __webpack_public_path__ + "img/checklist.46f5fa56.png";